import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.columnlist = {
    init: function(elt, va, allbindings, model, context) {
        var blank = ko.unwrap(allbindings().blank_data) || {};
        var model = {
            addField: function(ui, ev) {
                var newItem = ko.mapping.fromJS($.extend({}, blank));
                va().push(newItem);
            },
            deleteField: function(ui, ev) {
                va().remove(ui);
            },
            moveUpField: function(ui, ev) {
                var obs = va();
                var idx = obs.indexOf(ui);
                if (idx > 0) {
                    va().splice(idx-1, 0, va().splice(idx, 1)[0]);
                }
            },
            moveDownField: function(ui, ev) {
                var obs = va();
                var idx = obs.indexOf(ui);
                if (idx < obs().length - 1) {
                    va().splice(idx+1, 0, va().splice(idx, 1)[0]);
                }
            },
            canItemMoveUp: function(ui) { 
                var obs = va();
                var idx = obs.indexOf(ui);
                return idx > 0;
            },
            canItemMoveDown: function(ui) { 
                var obs = va();
                var idx = obs.indexOf(ui);
                return idx < obs().length - 1;
            },
            items: va()
        };
        var childContext = context.createChildContext(model);
        ko.applyBindingsToDescendants(childContext, elt);
        return { "controlsDescendantBindings": true };
    }
};
